import { render, staticRenderFns } from "./InfoWidget.vue?vue&type=template&id=43d99ef6&scoped=true&"
import script from "./InfoWidget.vue?vue&type=script&lang=js&"
export * from "./InfoWidget.vue?vue&type=script&lang=js&"
import style0 from "./InfoWidget.vue?vue&type=style&index=0&id=43d99ef6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d99ef6",
  null
  
)

component.options.__file = "InfoWidget.vue"
export default component.exports